// Dental AI detection (v1, async job). `image_url` may be a data URL (uploaded first) or a storage
// URL. POST starts a job and answers 202 {job_id}; GET reads it: pending, succeeded (result), or
// failed (problem). Polling lives in ./dentalAiJob.js.
import api, {withIdempotencyKey} from './client';

export const startDentalAi = ({image_url: image, dental_ai: model}, idempotencyKey, {signal} = {}) => {
  const body = {model};
  if (typeof image === 'string' && image.startsWith('data:')) body.image = image;
  else body.image_url = image;
  return api
    .post('/ai/detections', body, {...withIdempotencyKey(idempotencyKey), signal})
    .then((r) => r.data);
};

export const getDentalAiJob = (jobId, {signal} = {}) =>
  api.get(`/ai/detections/${encodeURIComponent(jobId)}`, {signal}).then((r) => r.data);
